"use client";

import { ReactNode } from "react";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import { ClarityWrapper } from "@stadium/services/ms-clarity";
import HubspotTracking from "@stadium/services/hubspot/tracking";
import HideHubspotFeedbackForm from "@stadium/services/hubspot/hide-hubspot-feedback-form";

import { useCurrentUserContext } from "@stadium/hooks/lib/use-current-user";

import { CLARITY_API_KEY } from "@constants/env-variables";
import { HUBSPOT_DEFAULT_CONFIG } from "@stadium/services/hubspot/constants";

const AppAnalyticsWrapper = ({ children }: { children: ReactNode }) => {
  const { currentUserData, loading } = useCurrentUserContext();
  const { spreeId, email } = currentUserData;
  const { asPath } = useRouter();
  return (
    <>
      <ClarityWrapper userId={spreeId} apiKey={CLARITY_API_KEY} isUserLoading={loading} />
      <HubspotTracking
        isUserLoading={loading}
        id={HUBSPOT_DEFAULT_CONFIG.portalId}
        path={asPath}
        email={email}
      >
        <HideHubspotFeedbackForm hideIcon={false} />
        {children}
      </HubspotTracking>
    </>
  );
};

export default AppAnalyticsWrapper;
